module.exports = __webpack_public_path__ + "img/chiptranz.e72167ac.jpg";